import { ExpandMore } from '@mui/icons-material'
import { Components, Theme } from '@mui/material'

export const MuiAccordion: Components<Omit<Theme, 'components'>>['MuiAccordion'] = {
  defaultProps: {
    disableGutters: true,
  },
  variants: [
    {
      // Rounded is our default shape; opt into square corners with `square`
      props: { square: true },
      style: {
        '&, &:first-of-type, &:last-of-type': {
          borderRadius: 0,
        },
        '& .MuiAccordionSummary-root': {
          borderRadius: 0,
        },
      },
    },
  ],
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.bg.invisible,
      '&.Mui-disabled': {
        backgroundColor: theme.palette.bg.invisible,
      },
      color: theme.palette.text.default,
      // MUI uses this to apply a default white highlight (via --Paper-overlay)
      backgroundImage: 'none',
      boxShadow: 'none',
      border: 'none',
      '&, &:first-of-type, &:last-of-type': {
        borderRadius: theme.shape['radius-lg'],
      },
      '& .MuiAccordionSummary-root': {
        borderRadius: theme.shape['radius-lg'],
      },
      // Remove border between Accordions when multiple are used together
      '&::before': {
        display: 'none',
      },
    }),
  },
}

export const MuiAccordionSummary: Components<Omit<Theme, 'components'>>['MuiAccordionSummary'] = {
  defaultProps: {
    // TODO - proper icon
    expandIcon: <ExpandMore />,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: 'unset',
      '&.Mui-expanded': {
        minHeight: 'unset',
      },
      padding: theme.spacing(0, 4, 0, 3),
      '&:hover': {
        backgroundColor: theme.palette.bg.interactive.hover,
      },
    }),
    content: ({ theme }) => ({
      '&, &.Mui-expanded': {
        margin: theme.spacing(2, 0),
      },
      ...theme.typography['body-semiBold'],
    }),
    expandIconWrapper: ({ theme }) => ({
      padding: theme.spacing(1),

      color: theme.palette.fg.muted,

      // TODO - updated icon
      '& .MuiSvgIcon-root': {
        fontSize: '20px',
      },
    }),
  },
}

export const MuiAccordionDetails: Components<Omit<Theme, 'components'>>['MuiAccordionDetails'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(2, 4, 4, 3),
    }),
  },
}

export const MuiAccordionActions: Components<Omit<Theme, 'components'>>['MuiAccordionActions'] = {}
